import React from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
import StaffsTable from '../StaffsTable';

const Accounts = ({
  handleViewDetail,
  toggleAddRecord,
  handleDelete,
  searchString,
}) => {
  return (
    <div>
      {' '}
      <ErrorBoundary>
        <StaffsTable
          handleViewDetail={handleViewDetail}
          toggleAddRecord={toggleAddRecord}
          handleDelete={handleDelete}
          searchString={searchString}
          department="ACCOUNTS"
        />
      </ErrorBoundary>
    </div>
  );
};

export default Accounts;
